import React from 'react';
import styled from 'styled-components';

import Button from '@joinforma/ui/components/Button';
import { ButtonVariant, ButtonSize } from '@joinforma/ui/constants/properties';
import Radio from '@joinforma/ui/components/Radio';
import RadioGroup from '@joinforma/ui/components/RadioGroup';

import ReplaceCardAddressForm from './ReplaceCardAddressForm';
import { Form, Field } from 'react-final-form';

interface Props {
  shipping_address?: {
    street: string;
    street2?: string;
    city: string;
    state: string;
    postalCode: string;
  };
  preferred_address?: {
    street?: string;
    street_ext?: string;
    locality?: string;
    state?: string;
    country?: string;
    zip?: string;
  };
  is_replace_card_address_open?: boolean;
  card_id?: string;
  replace_card_reason: string;
  onCancel: () => void;
  onContinue?: (reason: string) => void;
  refetchCards: () => void;
}

const RadioFormContainer = styled.form``;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 66px;
  gap: 10px;
`;

const SubmitButton = styled(Button).attrs({
  variant: ButtonVariant.PRIMARY,
  size: ButtonSize.LARGE,
})``;

const CancelButton = styled(Button).attrs({
  variant: ButtonVariant.SECONDARY,
  size: ButtonSize.LARGE,
})``;

const ReplaceCardRadioGroup = ({
  onCancel,
  onContinueToReplaceAddressForm,
}: {
  onCancel: () => void;
  onContinueToReplaceAddressForm?: (reason: string) => void;
}) => (
  <Form
    onSubmit={({ replace_reason }) => {
      onContinueToReplaceAddressForm &&
        onContinueToReplaceAddressForm(replace_reason);
    }}
    render={({ handleSubmit }) => (
      <RadioFormContainer onSubmit={handleSubmit}>
        <Field
          name="replace_reason"
          defaultValue={'lost'}
          render={({ input }) => (
            <RadioGroup {...input}>
              <Radio value="lost">My card was lost</Radio>
              <Radio value="stolen">My card was stolen</Radio>
              <Radio value="damaged">My card has been damaged</Radio>
            </RadioGroup>
          )}
        />
        <ButtonsContainer>
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
          <SubmitButton onClick={handleSubmit}>Continue</SubmitButton>
        </ButtonsContainer>
      </RadioFormContainer>
    )}
  />
);

const ReplacePhysicalCard = ({
  is_replace_card_address_open,
  shipping_address,
  preferred_address,
  onCancel,
  onContinue,
  refetchCards,
  card_id,
  replace_card_reason,
}: Props) =>
  is_replace_card_address_open ? (
    <ReplaceCardAddressForm
      onCancel={onCancel}
      shipping_address={shipping_address}
      preferred_address={preferred_address}
      replace_card_reason={replace_card_reason}
      confirm_button_text="Request new card"
      card_id={card_id}
      refetchCards={refetchCards}
    />
  ) : (
    <ReplaceCardRadioGroup
      onCancel={onCancel}
      onContinueToReplaceAddressForm={onContinue}
    />
  );

export default ReplacePhysicalCard;
